import type useBuefy from '@/shared/composables/useBuefy';

/**
 * Asks whether to leave the item editor, as whatever has not been saved in it is lost.
 * `onConfirm` runs only if the user agrees, and `onCancel` if they decide to stay.
 */
export function askToLeaveEditor(buefy: ReturnType<typeof useBuefy>, onConfirm: () => void, onCancel?: () => void): void {
    buefy.dialog.confirm({
        title: 'Leave the item editor?',
        message: 'Any unsaved changes to the item will be lost.',
        confirmText: 'Leave editor',
        type: 'is-warning',
        hasIcon: true,
        onConfirm,
        onCancel
    });
}
